import { FC } from 'react'
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/Alert/AlertDialog'
import { AlertDialog, AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { Loader } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { useDeletePromotion } from '../lib/use-delete-promotion'

type DeletePromotionAlertProps = {
  selectPromotionId: number
  onClose: () => void
}

export const DeletePromotionAlert: FC<DeletePromotionAlertProps & AlertDialogProps> = ({
  selectPromotionId,
  onClose,
  ...props
}) => {
  const { isLoadingDelete, handleDeletePromotion } = useDeletePromotion()
  const { t } = useTranslation(['promotion'])

  return (
    <AlertDialog {...props}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('promotion:confirmation.are_you_absolutely_sure')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('promotion:confirmation.action_cannot_be_undone')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoadingDelete}>
            {t('promotion:buttons.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isLoadingDelete}
            className='bg-red hover:bg-red/80'
            onClick={() => handleDeletePromotion(selectPromotionId, onClose)}
          >
            {isLoadingDelete ? <Loader color='white' size='xs' /> : t('promotion:buttons.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
